import React, { createContext, useEffect, useState } from "react";
import { getSortedCollection } from "sprint-common-web";

import { GetManzanitaPresetsLookupResponse } from "../../api/orders-api/manzanita-preset/responses/GetManzanitaPresetsLookupResponse";
import { useManzanitaPresetApi } from "../../api/orders-api/manzanita-preset/useManzanitaPresetApi";
import { ManzanitaPresetReference } from "../../types/ManzanitaPresetReference";

interface IManzanitaPresetsDataContext {
    manzanitaPresets: ManzanitaPresetReference[];
    isLoading: boolean;
}

export const ManzanitaPresetsDataContext = createContext<IManzanitaPresetsDataContext>({
    manzanitaPresets: [],
    isLoading: true
});

type ManzanitaPresetsDataProviderProps = React.PropsWithChildren<unknown>;

export const ManzanitaPresetDataProvider: React.FC<ManzanitaPresetsDataProviderProps> = ({
    children
}: ManzanitaPresetsDataProviderProps) => {
    const [manzanitaPresets, setManzanitaPresets] = useState<ManzanitaPresetReference[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const { getManzanitaPresetsLookup } = useManzanitaPresetApi();

    useEffect(() => {
        getManzanitaPresetsLookup()
            .then((response: GetManzanitaPresetsLookupResponse) => {
                const items = response.items.map((item) => ({
                    id: item.id,
                    name: item.name
                }));
                const sortedItems = getSortedCollection(items, "name");

                setManzanitaPresets(sortedItems);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <ManzanitaPresetsDataContext.Provider value={{ manzanitaPresets, isLoading }}>
            {children}
        </ManzanitaPresetsDataContext.Provider>
    );
};
